import React from "react";
import "./footer.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faWhatsapp, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faCopyright } from "@fortawesome/free-regular-svg-icons";

const Footer = () => {

    const openWhatsApp = () => {
        const whatsappURL = `https://wa.me/7339437623}`;
        window.open(whatsappURL, '_blank');
    };

    return (
        <div className="footer-container">
            <div className="copyrights-container">
                <FontAwesomeIcon className="copyrights-container__icon" icon={faCopyright} size="xs" />
                <span className="copyrights-container__content">2024 Bloobind. All rights reserved.</span>
            </div>
            <div className="social-media-container">
                <FontAwesomeIcon icon={faLinkedin} cursor="pointer" size="lg" />
                <FontAwesomeIcon icon={faWhatsapp} cursor="pointer" onClick={openWhatsApp} size="lg" />
                <FontAwesomeIcon icon={faInstagram} cursor="pointer" size="lg" />
            </div>
        </div>
    )

}

export default Footer;